import { Page, useTheme } from "@towersystems/roam-common-native";

export const TyroLogsScreen = () => {
  const { colors } = useTheme();
  return (
    <Page scrollable={false}>
      <iframe
        style={{
          height: "100%",
          outline: 0,
          borderWidth: 1,
          borderColor: colors.borderColor,
        }}
        src="https://iclient.tyro.com/logs.html"
      />
    </Page>
  );
};
